import { IMGIX_ASSETS_HOST } from 'data-layer/constants';

export const UPLOAD_ERROR_IMAGE_URL = {
  FILE_TOO_BIG: `${IMGIX_ASSETS_HOST}/assets/preview-images/photo_too_big.png`,
  FILE_TOO_SMALL: `${IMGIX_ASSETS_HOST}/assets/preview-images/photo_too_small.png`,
  UNKNOWN_FORMAT: `${IMGIX_ASSETS_HOST}/assets/preview-images/unknown_format.png`
} as const;
